import apiUrlConfig from 'configs/apiUrlConfig';
import AuthenticatedRequestService from 'services/requests/Authenticated';

const URLS = {
  INDEX: `${apiUrlConfig.apiEndPoint()}/input_types`,
};

class InputTypesApi {
  static fetchInputTypes() {
    return AuthenticatedRequestService.get(URLS.INDEX);
  }
}

export default InputTypesApi;



// WEBPACK FOOTER //
// ./src/apis/questions/InputTypes.js